import {context} from "../constants/context";
import Pusher from 'pusher-js';

class PusherFactory {

    /**
     * @param {Object} [options] Channels options parameter (see https://pusher.com/docs/client_api_guide/client_connect)
     * @param {string} [appKey]
     * @returns {null|Pusher} Return null if pusher notifications are disabled
     */
    static create(options = {}, appKey = context.pusher.appKey) {
        if (!context.pusher.enabled) {
            return null;
        }

        return new Pusher(appKey, options)
    }
}

export {
    PusherFactory
}